import React from 'react';
import { useTheme } from 'styled-components';

import { SVGPropsType } from 'src/types';

function BuySell(props: SVGPropsType) {
    const { onClick, style, className, direction, active } = props;
    const { colors } = useTheme();

    let first = colors.exchange.buy,
        second = colors.exchange.sell;
    if (direction === 'sell') {
        first = colors.exchange.sell;
        second = colors.exchange.buy;
    }

    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            {active ? (
                <rect width="24" height="24" rx="4" fill={colors.background.secondary.v3} />
            ) : null}

            <path
                d="M10.6667 6H6V10.8H10.6667V6Z"
                stroke={first}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.6667 13.2002H6V18.0002H10.6667V13.2002Z"
                stroke={second}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.9997 6H13.333"
                stroke={first}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.9997 10.7998H13.333"
                stroke={first}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.9997 8.3999H13.333"
                stroke={first}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.9997 13.2002H13.333"
                stroke={second}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.9997 18H13.333"
                stroke={second}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.9997 15.6001H13.333"
                stroke={second}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default BuySell;
